<template>
  <div class="page dialog-select">
    <header class="two-rows">
      <div>
        <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
        <div class="view-title">{{ 'through' | lang }}</div>
      </div>
      <div v-if="!loading">
        <div>{{ 'through_subtitle' | lang }}</div>
        <div class="floating-label" v-if="searchOptions.length > 15">
          <input v-model="searchString" placeholder=" " type="text" />
          <label>{{ 'filter' | lang }}</label>
        </div>
      </div>
    </header>
    <div v-if="loading"><div class="flexcentered bigger"><i class="fa fa-fw fa-refresh fa-spin"></i></div></div>
    <div v-scrolleffect v-els>
      <ul class="nav">
        <li v-for="(opt, idx) in showOptions" :key="idx" @click="next(opt)" @keypress.space="next(opt)" tabindex="0">
          <div class="title">{{opt.Label}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import newProductParameterMixin from '@/mixins/newProductParameterMixin'

export default {
  name: 'NewProductParameterPassaggio',
  mixins: [ page, newProductParameterMixin ],
  computed: {
    what () {
      return 'vias'
    }
  },
  methods: {
    saveParameter (id, label) {
      this.buying = { ...this.buying, via: {id, label}}
    },
    getData () {
      return this._getVias()
    }
  },
  mounted () {
    // this.searchOptions = this.searchOptions.slice(0, 3)
  }
}
</script>

<style></style>
